import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import { CloudUpload as UploadIcon, Description as FileIcon } from "@mui/icons-material";
import EmptyStateCard from "../../../../components/EmptyStateCard";
import useEvents from "../../../../hooks/useEvents";

type EmptyFilesProps = {
  onUploadFile: (files: FileList | null) => void;
};

const EmptyFiles = ({ onUploadFile }: EmptyFilesProps) => {
  const events = useEvents();
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };
  
  return (
    <Box data-testid="EmptyFilesView" style={{ margin: 24 }}>
      <EmptyStateCard
        text="Build your organization's shared file library! Upload resources that all your clients can access and benefit from."
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500, alignItems: "center" }} spacing={2}>
          <Typography style={{ textAlign: "center", marginBottom: 16 }}>
            Upload PDFs, documents, spreadsheets, images, videos, and more. 
            These files will be available to all clients in your organization 
            and can be shared in training plans and messages.
          </Typography>
          
          <StandardButton
            data-testid="EmptyFilesView-Button"
            variant="primary"
            startIcon={<UploadIcon />}
            onClick={() => {
              handleUploadClick();
              events.logButtonClick({
                buttonName: "Upload Your First File",
                pageName: "Library",
                tabName: "Files",
              });
            }}
            style={{ fontSize: 16 }}
          >
            Upload Your First File
          </StandardButton>
          
          <input
            ref={fileInputRef}
            type="file"
            hidden
            accept=".pdf,.csv,.doc,.docx,.txt,.xls,.xlsx,.zip,.rtf,.rar,.ppt,.pptx,.mp4,.mp3,.png,.jpg,.jpeg"
            onChange={(e) => {
              onUploadFile(e.target.files);
            }}
          />
          
          <Typography variant="caption" color="text.secondary" style={{ textAlign: "center", marginTop: 8 }}>
            <FileIcon sx={{ fontSize: 14, mr: 0.5 }} />
            Supported: PDF, DOC, XLS, PPT, images, videos, audio, ZIP, and more
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptyFiles;